import axios, { AxiosResponse } from 'axios';
import { CommonResult, createApiRequestUrl } from '../Common';
import { url } from 'inspector';

const URL = createApiRequestUrl('filter/store');

export interface FilterResponseAPI {
  filterName: string;
  filterId: number;
  sortOrder: number;
  updateDatetime: any | string;
  storeFilterVariableInfos: any[];
}
export interface FilterListResponse {
  result: CommonResult;
  filterStoreCds: FilterResponseAPI[];
}

export interface CommonAPIResponse {
  result: CommonResult;
}

export interface CreateFilterPayload {
  filterName: string;
  ordcstmCdList: string[];
}

export enum UpdateFilterType {
  UPDATE_ALL = 0,
  UPDATE_FILTER_SETTING = 1,
  UPDATE_FILTER_ORDER = 2,
}

export type UpdateOrderField = {
  filterId: number | string;
  sortOrder: number;
};
export interface UpdateFilterPayload {
  storeFilterUpdateRequest: {
    filterId: number | string;
    filterName: string;
    sortOrder: number;
    ordcstmCdList: string[];
  };
  updateType: UpdateFilterType;
  storeFilterOrderRequestList: UpdateOrderField[];
}

const getFilterSettingAPI = async (): Promise<AxiosResponse<FilterListResponse>> => {
  return axios.get<FilterListResponse>(URL);
};

const createFilterAPI = async (payload: CreateFilterPayload): Promise<AxiosResponse<CommonAPIResponse>> => {
  return axios.post<CommonAPIResponse>(URL, payload);
};

const updateFilterAPI = async (payload: UpdateFilterPayload): Promise<AxiosResponse<CommonAPIResponse>> => {
  return axios.patch<CommonAPIResponse>(URL, payload);
};

const deleteFilterAPI = async (filterID: number | string): Promise<AxiosResponse<CommonAPIResponse>> => {
  return axios.delete<CommonAPIResponse>(`${URL}/${filterID}`);
};

export { getFilterSettingAPI, createFilterAPI, updateFilterAPI, deleteFilterAPI };
